import * as React from "react";
const SvgLocation20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 20,
        fill: "black",
        viewBox: "0 0 16 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M4.708 3.525a5.74 5.74 0 0 1 7.624 8.47L8 16.975l-4.332-4.981a5.74 5.74 0 0 1 1.04-8.47Zm7.731-1.638a7.74 7.74 0 0 0-8.878 0C-.204 4.522-.857 9.839 2.16 13.307l5.087 5.85.754.867.755-.868 5.086-5.85c3.016-3.467 2.363-8.784-1.402-11.42ZM7 8a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm1-3a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z",
      clipRule: "evenodd"
    })
  );
export default SvgLocation20Px;
